export default __webpack_public_path__ + "static/media/cannonsmallbottomnew.499eb10c.png";